import { createRpcClientV2 } from 'rpc-client-utils';
import apiClient from 'hub-http/clients/apiClient';
import { getAvailableAppsRpc, getAvailableCurrentUserAppsRpc } from 'MeetingsLib/__generated__/chirp/com/hubspot/video/conference/extension/rpc/ApplicationsRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: apiClient
});
export function fetchApplicationsViaChirp(userId) {
  if (userId) {
    return chirpClient.call(getAvailableCurrentUserAppsRpc, {
      request: {
        userId
      }
    }).then(response => response.applications);
  }
  return chirpClient.call(getAvailableAppsRpc, {
    request: {}
  }).then(response => response.applications);
}